/**
 * @ComponentFor Avensia.Shop.Features.Cms.Blocks.ShortcutButtonsBlock.ShortcutButtonsBlockViewModel
 */
import React from "react";
import classnames from "classnames";
import * as styles from "./base.scss";
import ShortcutButtonBlock from "../ShortcutButtonBlock/ShortcutButtonBlock";
const ShortcutButtonsBlock = (props) => {
    return (React.createElement("div", { className: classnames(styles.shortcutButtonsBlock, !!props.passedStyles && props.passedStyles.shortcutButtonsContainer, props.disableTopPadding ? styles.disableTopPadding : "") },
        props.header &&
            (props.headerLevel === "h3" ? (React.createElement("h3", null, props.header)) : (React.createElement("h2", null, props.header))),
        React.createElement("div", { className: classnames(styles.container) }, props.buttons.map((button, index) => (React.createElement(ShortcutButtonBlock, { key: (!!props.tabIndex ? props.tabIndex + index : index), model: button, tabIndex: props.tabIndex }))))));
};
export default ShortcutButtonsBlock;
